import { Injectable } from '@angular/core';

import { select, Store } from '@ngrx/store';
import * as CurrentUserActions from './current-user.actions';
import * as CurrentuserSelectors from './current-user.selectors';
import { CurrentUserState } from './current-user.reducer';


@Injectable()
export class CurrentUserFacade {
  currentUserId$ = this.store.pipe(select(CurrentuserSelectors.getCurrentUserId));
  currentUserFireStoreError$ = this.store.pipe(select(CurrentuserSelectors.listenForCurrentUserFireStoreError));
  currentUser$ = this.store.pipe(select(CurrentuserSelectors.getCurrentUser));


  constructor(private store: Store<CurrentUserState>) {
  }




  loadCurrentuserFromFirestore() {
    const organizationUserId = localStorage.getItem('orgUid');
    console.log('LOAD CURRENT USER', organizationUserId);
    this.store.dispatch(CurrentUserActions.getFireStoreCurrentUser({
      organizationUserId
    }));
  }



}
